export const BRAND = {
  name: "Manvi Travels",
  tagline: "Come, see the world with us...",
  owner: "Sagar Nagpal",
  established: 2021,
  phoneDisplay: "+91 97020 45551",
  phoneHref: "tel:+919702045551",
  whatsapp:
    "https://wa.me/919702045551?text=Hi%20Sagar!%20I%20want%20to%20plan%20a%20holiday%20with%20Manvi%20Travels.",
  email: "sagar.mvtravels@gmail.com",
  address: "802, KK Grande, Sindhi Society, Chembur, Mumbai 400071",
  instagram: "https://www.instagram.com/manvitravels",
  googleRating: "4.7",
  maps: "https://maps.app.goo.gl/jaxVQGVUosDqhG949",
};

export const HERO_IMG = "img/hero.jpg";

export const ABOUT_IMGS = {
  main: "img/swiss.jpg",
  secondary: "img/dest-japan.jpg",
};

export const WHY_US = [
  {
    icon: "footprints",
    color: "teal",
    title: "First-hand experience",
    text: "Sagar has personally travelled close to 40 countries over more than a decade. Every recommendation comes from having actually been there — not from a brochure.",
  },
  {
    icon: "handshake",
    color: "coral",
    title: "Honest, genuine advice",
    text: "No tourist traps, no commissions-first planning. You get straightforward guidance on what is worth your time and what to skip.",
  },
  {
    icon: "timer",
    color: "navy",
    title: "Zero wasted time",
    text: "Itineraries are built so all the important places are covered at the minimum possible cost — your holiday days are never lost to guesswork.",
  },
  {
    icon: "headset",
    color: "green",
    title: "24/7 on-trip support",
    text: "While you are travelling, we are one call away at any hour — for route help, bookings, changes or anything unexpected.",
  },
  {
    icon: "compass",
    color: "plum",
    title: "The perfect location & timing",
    text: "We help you pick where to go, the best time to visit, and which nearby countries or cities can be smartly clubbed into one itinerary.",
  },
];

export const SERVICES = [
  { icon: "plane", label: "Flight Bookings" },
  { icon: "bed", label: "Hotels & Stays" },
  { icon: "visa", label: "Visa Support" },
  { icon: "shield", label: "Travel Insurance" },
  { icon: "headphones", label: "On-Trip Assistance" },
  { icon: "train", label: "Public Transport Routes & Tickets" },
  { icon: "car", label: "Self-Drive Car Rentals" },
  { icon: "food", label: "Indian & Veg Food Options" },
  { icon: "calendar", label: "Best Time to Visit Guidance" },
  { icon: "map", label: "Nearby Countries Clubbed In" },
];

export const DESTINATIONS = [
  {
    name: "Europe",
    region: "Europe",
    blurb: "Paris, Switzerland, Italy, Spain & more",
    img: "img/dest-europe.jpg",
  },
  {
    name: "Japan",
    region: "Asia",
    blurb: "Cherry blossoms, bullet trains, Tokyo & Kyoto",
    img: "img/dest-japan.jpg",
  },
  {
    name: "Dubai & UAE",
    region: "Middle East",
    blurb: "Skyline, desert & world-class shopping",
    img: "img/dest-dubai.jpg",
  },
  {
    name: "Bali",
    region: "Asia",
    blurb: "Beaches, rice terraces & villas",
    img: "img/dest-bali.jpg",
  },
  {
    name: "Iceland",
    region: "Europe",
    blurb: "Waterfalls, glaciers & northern lights",
    img: "img/dest-iceland.jpg",
  },
  {
    name: "United Kingdom",
    region: "Europe",
    blurb: "London, Scotland & the countryside",
    img: "img/dest-uk.jpg",
  },
  {
    name: "United States",
    region: "Americas",
    blurb: "New York, Las Vegas, Orlando & more",
    img: "img/dest-usa.jpg",
  },
  {
    name: "Turkey",
    region: "Asia",
    blurb: "Istanbul, Cappadocia & the Turquoise Coast",
    img: "img/dest-turkey.jpg",
  },
  {
    name: "Thailand",
    region: "Asia",
    blurb: "Bangkok, Phuket & island hopping",
    img: "img/dest-thailand.jpg",
  },
  {
    name: "Vietnam",
    region: "Asia",
    blurb: "Ha Long Bay, Hanoi & Hoi An",
    img: "img/dest-vietnam.jpg",
  },
  {
    name: "Russia",
    region: "Europe",
    blurb: "Moscow & St Petersburg",
    img: "img/dest-russia.jpg",
  },
  {
    name: "New Zealand",
    region: "Oceania",
    blurb: "Queenstown, fjords & alpine lakes",
    img: "img/dest-nz.jpg",
  },
  {
    name: "Australia",
    region: "Oceania",
    blurb: "Sydney, Melbourne & the Gold Coast",
    img: "img/dest-australia.jpg",
  },
  {
    name: "South Africa",
    region: "Africa",
    blurb: "Cape Town, wine country & safaris",
    img: "img/dest-sa.jpg",
  },
  {
    name: "Kenya",
    region: "Africa",
    blurb: "Classic safari & the great plains",
    img: "img/dest-kenya.jpg",
  },
  {
    name: "Tanzania",
    region: "Africa",
    blurb: "Serengeti, Zanzibar & Kilimanjaro",
    img: "img/dest-tanzania.jpg",
  },
  {
    name: "Malaysia",
    region: "Asia",
    blurb: "Kuala Lumpur & Langkawi",
    img: "img/dest-malaysia.jpg",
  },
  {
    name: "Singapore",
    region: "Asia",
    blurb: "Marina Bay & family fun",
    img: "img/dest-singapore.jpg",
  },
];

export const TEASER = [
  { name: "Europe", blurb: "Switzerland, Paris, Italy & more", img: "img/swiss.jpg", cls: "md:col-span-7 h-72" },
  { name: "Japan", blurb: "Our sharpest expertise", img: "img/dest-japan.jpg", cls: "md:col-span-5 md:row-span-2 md:h-[37.5rem] h-72" },
  { name: "Dubai & UAE", blurb: "Skyline, desert & shopping", img: "img/dest-dubai.jpg", cls: "md:col-span-7 h-72" },
  { name: "Bali", blurb: "Beaches & rice terraces", img: "img/dest-bali.jpg", cls: "md:col-span-6 h-72" },
  { name: "Iceland", blurb: "Waterfalls & northern lights", img: "img/dest-iceland.jpg", cls: "md:col-span-6 h-72" },
];

export const TRIPS = [
  { src: "trips/crop/trip-01.jpg", place: "Almaty, Kazakhstan" },
  { src: "trips/crop/trip-02.jpg", place: "Japan" },
  { src: "trips/crop/trip-03.jpg", place: "Kyoto, Japan" },
  { src: "trips/crop/trip-04.jpg", place: "Koh Samui, Thailand" },
  { src: "trips/crop/trip-05.jpg", place: "Shibuya, Japan" },
  { src: "trips/crop/trip-06.jpg", place: "Japan" },
  { src: "trips/crop/trip-07.jpg", place: "Bali, Indonesia" },
  { src: "trips/crop/trip-08.jpg", place: "Singapore" },
  { src: "trips/crop/trip-09.jpg", place: "Dubai, United Arab Emirates" },
  { src: "trips/crop/trip-10.jpg", place: "Europe" },
  { src: "trips/crop/trip-11.jpg", place: "Villa Nautica, Maldives" },
  { src: "trips/crop/trip-12.jpg", place: "Europe" },
  { src: "trips/crop/trip-13.jpg", place: "Tallinn, Estonia" },
  { src: "trips/crop/trip-14.jpg", place: "United States" },
  { src: "trips/crop/trip-15.jpg", place: "Japan" },
  { src: "trips/crop/trip-16.jpg", place: "France" },
  { src: "trips/crop/trip-17.jpg", place: "U.A.E." },
  { src: "trips/crop/trip-18.jpg", place: "Japan" },
  { src: "trips/crop/trip-19.jpg", place: "Japan" },
  { src: "trips/crop/trip-20.jpg", place: "Monaco" },
  { src: "trips/crop/trip-21.jpg", place: "Russia" },
  { src: "trips/crop/trip-22.jpg", place: "Denmark" },
  { src: "trips/crop/trip-23.jpg", place: "Japan" },
  { src: "trips/crop/trip-24.jpg", place: "Denmark" },
  { src: "trips/crop/trip-25.jpg", place: "Sweden" },
  { src: "trips/crop/trip-26.jpg", place: "Poland" },
  { src: "trips/crop/trip-28.jpg", place: "Norway" },
  { src: "trips/crop/trip-29.jpg", place: "Sweden" },
  { src: "trips/crop/trip-30.jpg", place: "Finland" },
  { src: "trips/crop/trip-31.jpg", place: "Norway" },
  { src: "trips/crop/trip-32.jpg", place: "Tanzania" },
];

export const FRAME_COLORS = [
  "border-gold",
  "border-coral",
  "border-teal",
  "border-navy",
  "border-plum",
];

export const DOT_COLORS = ["bg-gold", "bg-coral", "bg-teal", "bg-navy", "bg-plum"];

export const REGIONS = [
  "All",
  "Europe",
  "Asia",
  "Middle East",
  "Africa",
  "Americas",
  "Oceania",
];

export const slugify = (s) =>
  s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
